import * as React from "react";
import { Button } from "~/components/button";
import { Dialog } from "~/components/dialog";

export const useErrorDialog = ({
  defaultError,
}: { defaultError?: any } = {}) => {
  const [showErrorDialog, setShowErrorDialog] = React.useState<boolean>(false);
  const [error, setError] = React.useState<any>(defaultError);

  const ErrorDialog = React.useCallback(() => {
    return (
      <Dialog
        showDialog={showErrorDialog}
        setShowDialog={setShowErrorDialog}
        // preventDefaultClose
      >
        <Dialog.Header icon="alert-triangle">
          <Dialog.Title>Error</Dialog.Title>
        </Dialog.Header>
        <Dialog.Content>
          <p className="text-sm">
            {error?.message ?? "An error has occurred. Please try again."}
          </p>
        </Dialog.Content>
        <Dialog.Footer>
          <Button onClick={() => setShowErrorDialog(false)}>Dismiss</Button>
        </Dialog.Footer>
      </Dialog>
    );
  }, [showErrorDialog, setShowErrorDialog, error]);

  const showError = (error: any) => {
    setError(error);
    setShowErrorDialog(true);
  };

  return React.useMemo(
    () => ({ showError, setShowErrorDialog, ErrorDialog }),
    [showError, setShowErrorDialog, ErrorDialog],
  );
};
